<template>
  <div class="text-xs-center">
    <v-dialog :value="value" @input="$emit('input')" :width="computedWidth">
      <v-card>
        <v-card-title class="headline grey lighten-2 py-0 title-mobile" primary-title>
          {{ computedTitle }}
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <v-btn flat fab small icon @click="$emit('input')" slot="activator">
              <v-icon>close</v-icon>
            </v-btn>
            <span>Cancelar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn
              color="primary"
              fab
              dark
              small
              @click="adiciona"
              :loading="loading"
              slot="activator"
            >
              <v-icon>done</v-icon>
            </v-btn>
            <span>Salvar</span>
          </v-tooltip>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="motivo.Descricao"
                  label="Descrição"
                  prepend-icon="description"
                  @keyup.enter="adiciona"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import Motivo from '@/domain/motivo/Motivo';

export default {
  name: 'ModalCadastroMotivo',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    motivo: {
      type: Object,
      default: () => new Motivo()
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
    }
  },
  computed: {
    computedTitle() {
      return this.motivo.IdMotivo ? 'Editar Motivo' : 'Novo Motivo';
    },
    computedWidth() {
      return this.$vuetify.breakpoint.smAndDown ? '100%' : '60%';
    },
  },
  methods: {
    ...mapActions([
      'addMotivo',
      'updateMotivo',
    ]),
    ...mapMutations(['showNotification', 'closeNotification']),
    async adiciona() {
      if (!this.motivo.IdMotivo && this.motivo.Descricao) {
        this.loading = true;
        const newMotivo = Object.assign({}, this.motivo);
        try {
          await this.addMotivo(newMotivo);
          this.showNotification({ text: `Motivo: ${newMotivo.Descricao} adicionado com sucesso.`, status: 'success' });
          this.loading = false;
          this.$emit('input');
          this.$emit('motivoAdicionado');
        } catch (error) {
          this.showNotification({ text: `Ocorreu um erro ao adicionar o motivo: ${error}.`, status: 'error' });
        }
      } else if (this.motivo.IdMotivo && this.motivo.Descricao) {
        this.loading = true;
        const updMotivo = Object.assign({}, this.motivo);
        try {
          await this.updateMotivo(updMotivo);
          this.showNotification({ text: `Motivo: ${updMotivo.Descricao} atualizado com sucesso.`, status: 'success' });
          this.loading = false;
          this.$emit('input');
          this.$emit('motivoAdicionado');
        } catch (error) {
          this.showNotification({ text: `Ocorreu um erro ao atualizar o motivo: ${error}.`, status: 'error' });
        }
      } else {
        this.loading = false;
        this.showNotification({ text: `Informe a Descrição do motivo.`, status: 'error' });
      }
    }
  },
}
</script>

<style scoped>
@media screen and (max-width: 480px) {
  .title-mobile {
    font-size: 1.125rem !important;
  }
}
.cursor-pointer {
  cursor: pointer;
}
</style>
